export default class PerformanceTrack {
    /**
     * 
     * @param {string} subject 
     */
    constructor(subject) {
        /**
         * @constant
         * @type {string}
         */
        this.subject = subject;
        /**
         * @type {number}
         */
        this.startTime = performance.now();
        /**
         * @type {number}
         */
        this.elapsed = 0;
        /**
         * @type {number}
         */
        this.count = 0;
    }

    startTimer() {
        this.startTime = performance.now();
    }

    endTimer() {
        this.elapsed += performance.now() - this.startTime;
        this.count++;
    }

    reset() {
        this.startTime = performance.now();
        this.elapsed = 0;
        this.count = 0;
    }
}